import React from "react";
import Root from "./routes/Root";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import WebTheme from "./themes/WebTheme";
import { store } from "./store/store";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import {  HelmetProvider } from 'react-helmet-async';


function App() {

  return (
    <HelmetProvider>
    <Provider store={store}>
      <Toaster position="top-right" reverseOrder={false} />
      <ThemeProvider theme={WebTheme}>
        <Root />
      </ThemeProvider>
    </Provider>
    </HelmetProvider>
  );
}

export default App;
